import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { TooltipModule } from 'ngx-bootstrap';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { QuickQuoteContainerComponent } from './quick-quote-container.component';
import { QuickQuoteEntryComponent } from './quick-quote-entry.component';
import { BhtpComponentModule } from '@bhtp-client-web/component';
import { BhtpPurchaseServiceModule } from '@bhtp-client-api/purchase';
import { SharedModule } from './../shared/shared.module';
import { CoverageModalLinkComponent } from './../coverage-modal/coverage-modal-link.component';
import { CoverageModal } from './../coverage-modal/coverage-modal.component';
import { PackageCoverageSummaryComponent } from './../coverage-modal/package-coverage-summary.component';
import { CoverageLegendItemComponent } from './../coverage-modal/coverage-legend-item.component';
import { CoverageLegendComponent } from './../coverage-modal/coverage-legend.component';
import { IncludedCoveragesListComponent } from './../coverage-modal/included-coverages-list.component';
import { IncludedCoverageDisplayComponent } from './../coverage-modal/included-coverage-display.component';
import { BonusCoveragesComponent } from './../coverage-modal/bonus-coverages.component';

export { QuickQuoteContainerComponent } from './quick-quote-container.component';
export { CoverageModalLinkComponent } from './../coverage-modal/coverage-modal-link.component'
export { CoverageModal } from './../coverage-modal/coverage-modal.component';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        BhtpComponentModule,
        BhtpPurchaseServiceModule,
        SharedModule,
        NgbModule,
        TooltipModule.forRoot()
    ],
    declarations: [
        QuickQuoteContainerComponent,
        QuickQuoteEntryComponent,
        CoverageModalLinkComponent,
        CoverageModal,
        PackageCoverageSummaryComponent,
        CoverageLegendItemComponent,
        CoverageLegendComponent,
        IncludedCoveragesListComponent,
        IncludedCoverageDisplayComponent,
        BonusCoveragesComponent
    ],
    exports: [
        QuickQuoteContainerComponent,
        CoverageModalLinkComponent,
        CoverageModal
    ],
    providers: []
})
export class QuickQuoteModule { }


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/quick-quote/quick-quote.module.ts